import axios from "axios"

export default {
    actions: {
        loadCep(context, cep) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`https://brasilapi.com.br/api/cep/v1/` + cep)
                     .then(response => {
                        const data = response.data
                        // Normaliza a resposta da BrasilAPI para o formato esperado
                        resolve({
                            logradouro: data.street,
                            bairro: data.neighborhood,
                            localidade: data.city,
                            uf: data.state
                        })
                    })
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        loadCepVia(context, cep) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`https://viacep.com.br/ws/` + cep + `/json/`)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },
    },

    getters: {

    }

}